var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "virtual-tree",
    _vm._b(
      {
        attrs: {
          data: _vm.originTree,
          checked: _vm.checked,
          clearable: _vm.clearable,
          props: _vm.props,
          placeholder: _vm.placeholder,
          multiple: _vm.multiple
        },
        on: { change: _vm.checkedChange, "select-focus": _vm.dealSelectFocus }
      },
      "virtual-tree",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0434d212", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0434d212","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/insuranceTypeTree.vue
// module id = null
// module chunks = 